import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { ADDRESS_TYPE_HUB_CUSTOMER, ADDRESS_TYPE_ANOTHER_HUB, ADDRESS_TYPE_MERCHANT, ERROR_MESSAGES, ADDRESS_TYPE_MERCHANT_CUSTOMER } from 'src/utils/pnd/PndConstants';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import renderSelectField from 'src/shared/components/form/Select';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import HubCustomerInformation from './HubCustomerInformation';
import MerchantCustomerDetails from './MerchantCustomerDetails';

const required = value => (value !== undefined && value !== null && value !== '') ? undefined : 'Required';

const PickUpOrder = ({ assignedHubForCustomer, dispatch, isInfo, dropOffRequiredLaterValue }) => {
    const [addressTypeId, setAddressTypeId] = useState(null);
    const [isCustomersId, setCustomersId] = useState([]);
    const [isMerchantPickUpPoint, setMerchantPickUpPoint] = useState([]);
    const [isMerchant, setMerchant] = useState([]);
    const [isDropOffRequired, setDropOffRequired] = useState(false);
    const [isSelectedMid, setSelectedMid] = useState(null);

    useEffect(() => {
        getAllMerchantDetails();
        getAllCustomerDetails();

        if (dropOffRequiredLaterValue) {
            setDropOffRequired(true);
        }
        if (isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId) {
            const fromTypeId = Number(isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId);
            setAddressTypeId(fromTypeId);
            const mid = isInfo?.merchantInfo?.merchantId || isInfo?.merchantId || isInfo?.fromUniqueId;
            if (fromTypeId === ADDRESS_TYPE_MERCHANT && mid) {
                getAllMerchantPickupPointDetails(mid);
            }
            if (isInfo?.merchantInfo) {
                dispatch(change('orderForm', 'merchantInfo', {
                    value: isInfo.merchantInfo.merchantId,
                    label: isInfo.merchantInfo.merchantName
                }));
            }
            if (isInfo?.collectionPointId && isInfo?.collectionPointName) {
                dispatch(change('orderForm', 'collectionPointId', {
                    value: isInfo.collectionPointId,
                    label: isInfo.collectionPointName
                }));
            }
        }
    }, [dropOffRequiredLaterValue, isInfo, dispatch]);

    const getAllMerchantDetails = async () => {
        try {
            const response = await PndRestApi.GetAllMerchantDetails();
            const list = response?.data?.data || (Array.isArray(response?.data) ? response.data : []);
            let merchantIds = [];
            if (response && response.status === 200 && Array.isArray(list) && list.length > 0) {
                merchantIds = list.map(item => ({
                    label: item.merchantName,
                    value: item.merchantId
                }));
            } else if (response?.data?.status === 204 || (Array.isArray(list) && list.length === 0)) {
                const mi = localStorage.getItem("mi");
                const clientName = localStorage.getItem("clientName");
                if (mi) {
                    merchantIds.push({ label: clientName || "Merchant", value: Number(mi) });
                }
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response?.data?.status || 500}`, `Message:${response?.data?.message || 'Error fetching merchants'}`);
            }

            if (isInfo?.merchantInfo && !merchantIds.some(m => m.value === isInfo.merchantInfo.merchantId)) {
                merchantIds.unshift({
                    label: isInfo.merchantInfo.merchantName,
                    value: isInfo.merchantInfo.merchantId
                });
            }
            setMerchant(merchantIds);
        } catch (error) {
            console.error("Error fetching merchant details:", error);
            let merchantIds = [];
            if (isInfo?.merchantInfo) {
                merchantIds.push({
                    label: isInfo.merchantInfo.merchantName,
                    value: isInfo.merchantInfo.merchantId
                });
            } else {
                const mi = localStorage.getItem("mi");
                const clientName = localStorage.getItem("clientName");
                if (mi) {
                    merchantIds.push({ label: clientName || "Merchant", value: Number(mi) });
                } else {
                    showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
                }
            }
            setMerchant(merchantIds);
        }
    };

    const getDropOffRequiredLater = (events) => {
        setDropOffRequired(!!events);
        if (events) getAllCustomerDetails();
    }

    const getAllCustomerDetails = async () => {
        try {
            let customersId = [];
            const response = await PndRestApi.GetAllHubCustomers();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    customersId.push({ "label": item.customerName, "value": item.hubCustomerId });
                });
                setCustomersId(customersId);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data?.message || "Error"}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const getAllMerchantPickupPointDetails = async (mid) => {
        try {
            const actualMid = mid?.value !== undefined ? mid.value : (mid?.target?.value !== undefined ? mid.target.value : mid);
            if (!actualMid) return;
            setSelectedMid(actualMid);
            let pickUpPointsId = [];
            setMerchantPickUpPoint([]);
            const response = await PndRestApi.GetAllPickUpPointsDetails(actualMid);
            const list = response?.data?.data || (Array.isArray(response?.data) ? response.data : []);
            if (response && response.status === 200 && Array.isArray(list)) {
                list.forEach(item => {
                    pickUpPointsId.push({ "label": item.collectionPointName, "value": item.pickUpPointPointId });
                });
                setMerchantPickUpPoint(pickUpPointsId);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response?.data?.status || 500}`, `Message:${response?.data?.message || "Error"}`);
                dispatch(change('orderForm', `collectionPointId`, null));
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const findAddressType = (val) => {
        const typeId = val?.value !== undefined ? val.value : (val?.target?.value !== undefined ? val.target.value : val);
        const numId = Number(typeId);
        setAddressTypeId(numId);
        if (numId === ADDRESS_TYPE_MERCHANT) getAllMerchantDetails();
        if (numId === ADDRESS_TYPE_HUB_CUSTOMER) getAllCustomerDetails();
    }

    return (
        <div className="mt-2">
            <Row className="g-2 mb-3">
                <Col lg={3} md={6}>
                    <div className="mb-1">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pick Up From <span className='text-danger'>*</span></label>
                        <Field validate={[required]} name="orderFromAddressTypeInfo" component={renderSelectField} options={[
                            { value: 2, label: "Hub Customer" },
                            { value: 3, label: "Merchant" },
                            { value: 4, label: "Another Hub" },
                        ]} placeholder="Select Pickup Type" onChange={(event, newValue) => findAddressType(newValue || event)} isDisabled={!!isInfo?.orderNo} />
                    </div>
                </Col>

                {Number(addressTypeId) === ADDRESS_TYPE_ANOTHER_HUB && (
                    <Col lg={3} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Source Hub <span className='text-danger'>*</span></label>
                            <Field validate={[required]} name="hubInfo" component={renderSelectField} options={assignedHubForCustomer} placeholder="Select Hub" />
                        </div>
                    </Col>
                )}

                {Number(addressTypeId) === ADDRESS_TYPE_MERCHANT && (
                    <>
                        <Col lg={3} md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Merchant <span className='text-danger'>*</span></label>
                                <Field validate={[required]} name="merchantInfo" component={renderSelectField} options={isMerchant} placeholder="Select Merchant" onChange={(event, newValue) => getAllMerchantPickupPointDetails(newValue || event)} isDisabled={!!isInfo?.orderNo} />
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pickup Point <span className='text-danger'>*</span></label>
                                <Field validate={[required]} name="collectionPointId" component={renderSelectField} options={isMerchantPickUpPoint} placeholder="Select Point" isDisabled={!!isInfo?.orderNo} />
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off Later?</label>
                                <div className="mt-1">
                                    <Field name="dropOffRequiredLater" component={renderToggleButtonField} onChange={getDropOffRequiredLater} defaultChecked={dropOffRequiredLaterValue} />
                                </div>
                            </div>
                        </Col>
                    </>
                )}
            </Row>

            {Number(addressTypeId) === ADDRESS_TYPE_HUB_CUSTOMER && (
                <HubCustomerInformation isCustomersId={isCustomersId} />
            )}

            {isDropOffRequired && Number(addressTypeId) === ADDRESS_TYPE_MERCHANT && (
                <HubCustomerInformation isCustomersId={isCustomersId} />
            )}

            {Number(addressTypeId) === ADDRESS_TYPE_MERCHANT_CUSTOMER && (
                <MerchantCustomerDetails isCustomersId={isCustomersId} />
            )}
        </div>
    );
};

PickUpOrder.propTypes = {
    isInfo: PropTypes.object,
    assignedHubForCustomer: PropTypes.array,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(PickUpOrder));
